import InspectionStatusFactory from './inspection_state';

class Inspection {
  PENDING_WEEKS = 2;

  constructor(inspection) {
    this.inspection = inspection;
  }

  get htmlClass() {
    return this.inspection.overdue ? 'overdue' : this.inspection.incoming ? 'incoming' : '';
  }

  get done() {
    return this.inspection.status === InspectionStatusFactory.DONE;
  }

  static create(inspection) {
    return new Inspection(inspection);
  }
}

const InspectionFactory = (inspection = null) => new Inspection(inspection);

export default InspectionFactory;
